import Image from 'next/image';

import { ImageCopyright } from '../../../design-system/components/image/copyright/ImageCopyright';
import { Ratio, RATIO } from '../../../design-system/components/ratio/Ratio';
import { TriplePictureSlice } from '../../../domains/Prismic/DestinationDetailDocument';
import { NullableSlice } from '../../../domains/Prismic/Utilities';

import style from './TriplePictures.module.css';

export type TriplePicturesProps = {
    triplePictures: NullableSlice<TriplePictureSlice>;
};

export function TriplePictures({ triplePictures }: TriplePicturesProps) {
    const images = [
        {
            image: triplePictures.firstPicture,
            copyright: triplePictures.firstPictureCopyright,
        },
        {
            image: triplePictures.secondPicture,
            copyright: triplePictures.secondPictureCopyright,
        },
        {
            image: triplePictures.thirdPicture,
            copyright: triplePictures.thirdPictureCopyright,
        },
    ];

    return (
        <div className={style.wrapper}>
            {images.map(({ image, copyright }) => {
                return (
                    <div key={image?.url} className={style.column}>
                        <Ratio ratio={RATIO['4/5']}>
                            {image?.url ? (
                                <Image
                                    className={style.image}
                                    alt={image.alt}
                                    src={image.url}
                                    unoptimized
                                    fill
                                />
                            ) : null}
                            {copyright ? <ImageCopyright copyright={copyright} /> : null}
                        </Ratio>
                    </div>
                );
            })}
        </div>
    );
}
